import axios from "axios";

export class kioskStatus {
  constructor() {
    this.init();
  }

  async init() {
    const onlineTimeRange =
      localStorage.getItem("online_time_range") === null ||
      localStorage.getItem("online_time_range") == 0
        ? 120000
        : localStorage.getItem("online_time_range");
    setInterval(() => {
      this.sendKioskStatus();
    }, onlineTimeRange);
  }
  
  async sendKioskStatus() {
    if (localStorage.getItem("appToken")) {
      if (localStorage.getItem("branch_id")) {
        try {
          let uuiiKiosko = localStorage.getItem("uuii_kiosko");
          if (uuiiKiosko) {
            let params = {
              uuiiKiosko: localStorage.getItem("uuii_kiosko"),
            };
            await axios
              .post(`api/v1/kiosk/is_kiosk_online`, params)
              .then((response) => {
                console.log("La petición ha sido exitosa");
              });
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
  }
}
